import mitt from 'mitt';
import type { Handler } from 'mitt';

type Key = string;
export type AddEventListener = (key: Key, listener: Handler) => void;
const addListener = () => {
    const emitter = mitt();
    const addEventListener: AddEventListener = (key, listener) => {
        emitter.on(key, listener);
    };

    const emitListener = (key: Key, event?: any) => {
        emitter.emit(key, event);
    };

    return { addEventListener, emitListener };
};

export default addListener;
